<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <h1 class="top-margin-15">Kedvezmény szerkesztése</h1>
  </ng-template>

  <form [formGroup]="formGroup">
    <!-- product -->
    <payee-form-field width="max">
      <span payee-label>Termék</span>
      <payee-autocomplete
        formControlName="product"
        width="max"
        [options]="productOptions"
        [displayWith]="productDisplayWith"
      ></payee-autocomplete>
      @if (product.dirty) {
        <ng-container payee-error>
          @if (product.hasError("required")) {
            <div>A mező kitöltése kötelező!</div>
          }
        </ng-container>
      }
    </payee-form-field>

    <!-- product_discountable_type -->
    <payee-dropdown
      formControlName="product_discountable_type"
      width="max"
      [options]="productDiscountableTypeOptions"
    >
      <span payee-label>Kedvezményezett típusa</span>
      @if (product_discountable_type.dirty) {
        <ng-container payee-error>
          @if (product_discountable_type.hasError("required")) {
            <div>A mező kitöltése kötelező!</div>
          }
        </ng-container>
      }
    </payee-dropdown>

    <!-- product_discountable -->
    <payee-form-field width="max">
      <div
        payee-label
        class="flex vcenter"
      >
        <span>Kedvezményezett</span>
        @if (productDiscountableOptionsLoading) {
          <mat-progress-spinner
            diameter="24"
            mode="indeterminate"
          ></mat-progress-spinner>
        }
      </div>
      <payee-autocomplete
        formControlName="product_discountable"
        width="max"
        [options]="productDiscountableOptions"
        [displayWith]="productDiscountableDisplayWith"
        (searchChange)="setProductDiscountableOptionsSubject.next($event)"
      ></payee-autocomplete>
      @if (product_discountable.dirty) {
        <ng-container payee-error>
          @if (product_discountable.hasError("required")) {
            <div>A mező kitöltése kötelező!</div>
          }
        </ng-container>
      }
    </payee-form-field>

    <!-- discount_type -->
    <payee-dropdown
      formControlName="discount_type"
      width="max"
      [options]="discountTypeOptions"
    >
      <span payee-label>Kedvezmény típusa</span>
      @if (discount_type.dirty) {
        <ng-container payee-error>
          @if (discount_type.hasError("required")) {
            <div>A mező kitöltése kötelező!</div>
          }
        </ng-container>
      }
    </payee-dropdown>

    <!-- discount -->
    <payee-form-field width="max">
      <span payee-label>Kedvezmény mértéke</span>
      @if (discount_type.value === "amount") {
        <span payee-suffix>
          {{ (fee.value || productDiscount.fee)?.currency_iso }}
        </span>
      }
      @if (discount_type.value === "percentage") {
        <span payee-suffix>%</span>
      }
      <input
        payee-input
        formControlName="discount"
      />
    </payee-form-field>

    <!-- fee -->
    <payee-form-field width="max">
      <div
        payee-label
        class="flex vcenter"
      >
        <span>Díj</span>
        @if (feeOptionsLoading) {
          <mat-progress-spinner
            diameter="24"
            mode="indeterminate"
          ></mat-progress-spinner>
        }
      </div>
      <payee-autocomplete
        formControlName="fee"
        width="max"
        [options]="feeOptions"
        [displayWith]="feeDisplayWith"
        (searchChange)="setFeeOptionsSubject.next($event)"
      ></payee-autocomplete>
      @if (fee.dirty) {
        <ng-container payee-error>
          @if (fee.hasError("required")) {
            <div>A mező kitöltése kötelező!</div>
          }
        </ng-container>
      }
    </payee-form-field>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      [isBorderButton]="true"
      (click)="cancel()"
    >
      Mégsem
    </button>
  </ng-template>
</payee-popup>
